// extracted by mini-css-extract-plugin
export var downArrow = "_ak-0";
export var infoTooltipIcon = "_ak-3";
export var label = "_ak-1";
export var optionCard = "_ak-4";
export var upArrow = "_ak-2";